import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import DynamicContent from "../../components/DynamicContent";
import { getPost, getPage } from "ab-api-queries";

const Home = ({ post, translations }) => {
  console.log("Blog Slug ", translations);
  const { i18n } = useTranslation("common");
  return (
    <>
      <div className="blog-post-header">
        <h1>{post.title}</h1>
      </div>

      {post?.contenidoFlexible?.modulos?.map((itm, index) => (
        <DynamicContent
          {...itm}
          key={`${itm.fieldGroupName}-${index}`}
          i18n={i18n}
        />
      ))}
    </>
  );
};

export async function getServerSideProps({ locale, params }) {
  const data = await getPost(`${params.slug}`);
  const dataBlog = await getPage(`/en/en-blog`);
  // console.log("Blog Slug ", params.slug);

  const _translations = data?.post?.translations
    ? data?.post?.translations?.map((translation) => {
        if (translation?.language?.code == "ES") {
          return { ...translation, blog: "blog/" };
        }
      })
    : null;
  const translations = await serverSideTranslations(locale, ["common"]);
  return {
    props: {
      post: data?.post || [],
      footer: dataBlog?.headerFooter?.footer,
      menu: dataBlog?.headerFooter?.menu,
      translations: _translations,
      language: data?.post?.language,
      moduloCross: data?.modulosCross || null,
      ...translations,
    }, // will be passed to the page component as props
    notFound: !data?.post || locale !== "en",
  };
}

export default Home;
